module.exports = __webpack_public_path__ + "img/39ne.f1fa995d.svg";